import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import sessionStorage from 'redux-persist/es/storage/session';
import { RootState } from '@store/store';

interface IRoundRobin {
  alertToken: string | null;
}

const initialState: IRoundRobin = {
  alertToken: null,
};

export const roundRobinSlice = createSlice({
  name: 'roundRobin',
  initialState,
  reducers: {
    setRoundRobinAlertToken: (state, action: PayloadAction<string | null>) => {
      state.alertToken = action.payload;
    },
  },
});

export const { setRoundRobinAlertToken } = roundRobinSlice.actions;

export const roundRobinAlertToken = (state: RootState) => state.roundRobin.alertToken;

export const roundRobinPersistConfig = {
  key: 'roundRobin',
  storage: sessionStorage,
};
